<span
  class="app-action-loader"
  [class.app-action-loader--active]="active"
  [attr.aria-label]="resolvedAriaLabel"
  [attr.aria-busy]="active ? 'true' : null"
  [attr.aria-disabled]="disabledState ? 'true' : null"
>
  <span class="app-action-loader__content">
    <mat-spinner
      *ngIf="active && showSpinner"
      class="app-action-loader__spinner"
      diameter="16"
      aria-hidden="true"
    ></mat-spinner>

    <span class="app-action-loader__label">{{ resolvedLabel }}</span>
  </span>
</span>
